function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent } from "vue";
import { definePropType } from "@types-vue/props";
import { Unread } from "@pt/api/message/enum";
import MessageContent from "./content.vue";
import { colorStyle, getMessageTitle, getMessageContent, setMessageReadFun } from "./index";
export default defineComponent({
    components: {
        MessageContent: MessageContent
    },
    props: {
        drawer: {
            type: Boolean,
            default: false
        },
        data: {
            type: definePropType(Array),
            required: true
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleClose = function() {
            emit("update:drawer", false);
        };
        var handleShowItem = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(item) {
                var flag;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(item.status === Unread.Send)) {
                                _ctx.next = 5;
                                break;
                            }
                            _ctx.next = 3;
                            return setMessageReadFun([
                                {
                                    id: item.msg_id,
                                    seq: item.seq
                                }, 
                            ]);
                        case 3:
                            flag = _ctx.sent;
                            if (flag) {
                                item.status = Unread.Read;
                            }
                        case 5:
                            item.show = !item.show;
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function handleShowItem(item) {
                return _ref.apply(this, arguments);
            };
        }();
        return {
            colorStyle: colorStyle,
            handleClose: handleClose,
            handleShowItem: handleShowItem,
            getMessageTitle: getMessageTitle,
            getMessageContent: getMessageContent
        };
    }
});
